import { mergeClasses } from '@/utils';

export const Loading = ({ fullScreen }: { fullScreen?: boolean }) => {
  return (
    <div
      className={mergeClasses(
        'inset-0 flex flex-col items-center justify-center bg-opacity-light-70 z-[100]',
        fullScreen ? 'fixed' : 'absolute',
      )}
    >
      <span className="w-12 h-12 border-[5px] border-brand-primary-base border-b-transparent rounded-full inline-block box-border animate-spin"></span>
      <span className="font-semibold text-base text-neutral-n9">Loading...</span>
    </div>
  );
};
